// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.practicepreferences.WebServiceUserResponse */
/* istanbul ignore next */
@GandalfModel
export class WebServiceUserResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfProperty({ designType: Boolean })
	enabled!: boolean | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	partnerKey!: string | null;

	@GandalfProperty({ designType: String })
	remotePassword!: string | null;

	@GandalfProperty({ designType: String })
	remoteUserName!: string | null;

	@GandalfConstantDecorator(constants.WebServiceUserServiceType)
	@GandalfProperty({ designType: constants.WebServiceUserServiceType })
	serviceType!: constants.WebServiceUserServiceType | null;

}
